import React from 'react';

const AboutUs = () => {
  return (
    <>
      <section className="common aboutUs">
        <div className="container">
          <div className="mainTit">
            <h2>About us</h2>
            <p>Home > About us</p>
          </div>
        </div>
      </section>
      <section className="greetings">
        <div className="w1200">
          <h2>
            <span className="blue">고객의 Needs를 분석</span>하여
            <br /> 고객 만족도를 <br className="w490" /> 최우선으로 생각하는 기업
          </h2>
          <div className="pGroup">
            <p>
              <span className="bold">
                고객과 함께하는 WithUs Security <br className="w640" /> (위더스 시큐리티)
              </span>
              는<br className="w800" /> 고객의 안전한 사무 환경 제공을 위해
              <br className="w358" /> 앞장 서는 기업으로 항상 최고의 솔루션으로
              <br className="w640" /> 고객에게 보답하고자 합니다.
            </p>
            <p>
              고객 비즈니스 의사소통을 안전하게 책임질
              <br className="w640" /> 이메일 보안 솔루션을 대표로 고객 업무 환경에
              <br className="w358" /> 알맞은 솔루션을 가장 쉽고 편리하게 제공해
              <br className="w600" /> 드릴 수 있도록 항상 노력하겠습니다.
            </p>
            <p className="noMargin">
              항상 고객의 니즈를 충족시킬 수 있는
              <br className="w640" /> 솔루션을 공급해 신뢰 있는 기업,
              <br className="w800" /> 시장을 선도하는 기업이 되겠습니다. <br className="w358" />
              앞으로 위더스 시큐리티의 힘찬 도약을 <br className="w640" /> 함께 응원해 주시기
              바랍니다.
              <br />
              감사합니다.
            </p>
          </div>
          <h3>CEO 최진태</h3>
        </div>
      </section>
      <section className="vision">
        <div className="w1200">
          <h2>Mission & Vision</h2>
          <p>
            차별화된 오피스 솔루션으로 <br className="show595" /> 안전하고 편리한 기업 업무 환경을
            구축하는 &nbsp;
            <br className="show595" />
            IT전문기업&nbsp;
            <br className="w595" />
            ‘고객과 함께 하는 기업’ 이라는 <br className="show595" /> 소명을 바탕으로 고객과
            소통하며 <br className="show595" /> 신뢰할 수 있는 기업이 되겠습니다.
          </p>
          <figure>
            <img src="/images/sub_about_02.png" alt="mission&vision" className="pc" />
            <img src="/images/sub_about_02_800.png" alt="mission&vision" className="w800" />
            <img src="/images/sub_about_02_400.png" alt="mission&vision" className="w400" />
          </figure>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
